import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';
import {FormArray, FormControl, FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilsHelper {

  public static IsNilOrEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true
    }

    if (Array.isArray(value)) {
      return value.length === 0;
    }

    return false;
  }

  public static sleep(ms: number) {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }

  public static getHumanFormatedDate(date: Date) {
    if (!date) return '';
    return moment(date).format('dddd D MMMM YYYY');
  }

  public static getFormUpdates(formItem: FormGroup | FormArray | FormControl) {
    const updatedValues: Record<string, any> = {};
    this.getUpdates(formItem, updatedValues);

    return updatedValues;
  }

  private static getUpdates(
    formItem: FormGroup | FormArray | FormControl,
    updatedValues: Record<string, any>,
    name?: string
  ) {
    if (formItem instanceof FormControl) {
      if (name && formItem.dirty) {
        updatedValues[name] = formItem.value;
      }
    } else {
      for (const formControlName in formItem.controls) {
        if (formItem.controls.hasOwnProperty(formControlName)) {
          const formControl = formItem.controls[formControlName];

          if (formControl instanceof FormControl) {
            this.getUpdates(formControl, updatedValues, formControlName);
          } else if (
            formControl instanceof FormArray &&
            formControl.dirty &&
            formControl.controls.length > 0
          ) {
            updatedValues[formControlName] = [];
            this.getUpdates(formControl, updatedValues[formControlName]);
          } else if (formControl instanceof FormGroup && formControl.dirty) {
            updatedValues[formControlName] = {};
            this.getUpdates(formControl, updatedValues[formControlName]);
          }
        }
      }
    }
  }
}
